import { useIsMobile } from "../../../hooks/useMobile";
import DashboardSurveyList from "../components/dashboard-survey-list.component";
import DashboardSurveyTable from "../components/dashboard-survey-table.component";
import SurveyDrawer from "../components/surveys/survey-drawer";
import { Survey } from "src/redux/survey/survey.types";
import { useState } from "react";

const SurveysTab = () => {
  const { isMobile } = useIsMobile();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [activeSurvey, setActiveSurvey] = useState<Survey | null>(null);
  const [actionType, setActionType] = useState<'assign-client' | null>(null);

  const handleSurveyAction = (survey: Survey, action: 'assign-client') => {
    setActiveSurvey(survey);
    setActionType(action);
    setIsDrawerOpen(true);
  };

  const handleDrawerOpenChange = () => {
    setIsDrawerOpen(false);
    setActiveSurvey(null);
    setActionType(null);
  };

  return (
    <>
      {isMobile ? <DashboardSurveyList onSurveyAction={handleSurveyAction} /> : <DashboardSurveyTable onSurveyAction={handleSurveyAction} />}
      <SurveyDrawer
        open={isDrawerOpen}
        onOpenChange={handleDrawerOpenChange}
        type={actionType}
        activeSurvey={activeSurvey}
      />
    </>
  );
};

export default SurveysTab;
